import { render, staticRenderFns } from "./SyncTaskProgressModal.vue?vue&type=template&id=22b57e3e"
import script from "./SyncTaskProgressModal.vue?vue&type=script&lang=js"
export * from "./SyncTaskProgressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports